/**
 * Created by olga on 22.09.2026
 */

const PinComponent = function (unit) {
    UnitComponent.call(this, unit);
};

PinComponent.prototype = Object.create(UnitComponent.prototype);
PinComponent.prototype.constructor = PinComponent;

PinComponent.prototype.handleDragStart = function () {
    if (this.view) {
        this.view.highlightDrag();
    }
};

PinComponent.prototype.handleDragMove = function (rawX, rawY, handled) {
    return !handled && Boolean(this.findAffectedUnit(rawX, rawY, true));
};

PinComponent.prototype.handleDragEnd = function (rawX, rawY, cancelled) {
    this.unHighlightDrag();

    const affected = this.findAffectedUnit(rawX, rawY, cancelled);

    if (affected && !cancelled) {
        this.openConfirmation(affected);
        return true;
    }
};

PinComponent.prototype.openConfirmation = function (affected) {
    cleverapps.focusManager.display({
        focus: "PinConfirmationWindow",
        action: (f) => {
            new PinConfirmationWindow(this, affected);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

PinComponent.prototype.unHighlightDrag = function () {
    if (this.view) {
        this.view.unHighlightDrag();
    }
};

PinComponent.prototype.isAffectedUnit = function (unit) {
    return this.isPinnable(unit);
};

PinComponent.prototype.isPinnable = function (unit) {
    return Boolean(unit.findComponent(ThirdElement)) && !unit.isBlocked();
};

PinComponent.prototype.onWrongTarget = function () {
    Merge2.current.showHint(this.unit.onGetView(), Messages.get("Pin.wrongTarget"));
};

PinComponent.prototype.apply = function (target) {
    const thirdElement = target.findComponent(ThirdElement);
    if (Merge2.current.field.getUnit(target.x, target.y) !== target) {
        this.unit.resetDrag();
        return;
    }

    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTER_USE}-${this.unit.code}`, { itemId: thirdElement.prize.code, value: thirdElement.prize.stage });
    cleverapps.playSession.logEventOnce(`${cleverapps.EVENTS.BOOSTER_USE_DAU}-${this.unit.code}`);

    thirdElement.accept({ animation: "pin", keepInPlace: true, delay: PinComponent.POP_DELAY });

    if (this.view) {
        this.view.playClose();
    }
    this.unit.remove(true);
};

PinComponent.POP_DELAY = 0.5;

PinComponent.prototype.handleRemove = function () {
    this.unHighlightDrag();
};

PinComponent.prototype.destructor = function () {
    this.unHighlightDrag();
};
